type StatusKind = 'positive' | 'warning' | 'muted' | 'critical'

type ToggleButtonProps = {
  label: string
  enabled: boolean
  onToggle: (enabled: boolean) => void
  disabled?: boolean
  dotColor?: StatusKind
}

const STATE_TO_DOT_CLASS: Record<StatusKind, string> = {
  positive: 'status-dot--positive',
  warning: 'status-dot--warning',
  muted: 'status-dot--muted',
  critical: 'status-dot--critical',
}

export function ToggleButton({
  label,
  enabled,
  onToggle,
  disabled = false,
  dotColor = 'positive'
}: ToggleButtonProps) {
  const dotClass = enabled ? STATE_TO_DOT_CLASS[dotColor] : STATE_TO_DOT_CLASS.muted

  return (
    <button
      className="btn toggle-btn"
      onClick={() => onToggle(!enabled)}
      disabled={disabled}
      aria-pressed={enabled}
    >
      <span className={`status-dot ${dotClass}`} aria-hidden />
      <span>{label}</span>
    </button>
  )
}
